//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    src: {
      type: String,
      require: true,
      default: '',
    },
    alt: {
      type: String,
      require: true,
      default: '',
    },
    width: {
      type: Number,
      default: 200,
    },
    height: {
      type: Number,
      default: 200,
    },
    quality: {
      type: Number,
      default: 60,
    },
    ossResize: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    compressSrc() {
      if (this.ossResize) {
        return `${this.src}?x-oss-process=image/resize,m_fixed,w_${
          this.width * 2
        },h_${this.height * 2}/quality,Q_${this.quality}`;
      } else {
        return this.src;
      }
    },
  },
};
